module.exports = __webpack_public_path__ + "static/engineeringStory2-fba013d5b6056a0709a17e4b6c174b31.jpg";